module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', [_vm._s(_vm.bannerInfo.imgRemark)])]), " ", _vm._h('div', {
    staticClass: "liner"
  })]), " ", _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "main-page bg-white"
  }, [_vm._h('div', {
    attrs: {
      "id": "myIframe"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-57ec1962!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/ad/AdInfo.vue
// module id = 205
// module chunks = 1